import { MagicResult } from '../model';
import { MagicGenerateRequest, MagicProvider } from './types';

// Demo provider used when there is no API key and the backend proxy is off, so
// the studio stays explorable end-to-end without credentials. It echoes the
// first reference image back as the "generated" result after a short delay.
const FAKE_LATENCY_MS = 1400;

export function createFakeProvider(): MagicProvider {
  return {
    id: 'fake',
    supportsModel: () => true,
    generate(req: MagicGenerateRequest): Promise<MagicResult> {
      const first = req.images[0];
      const seedImageUrl = first ? `data:${first.mimeType};base64,${first.dataBase64}` : null;
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            id: `gen_${Date.now()}`,
            seed: Math.floor(Math.random() * 99999),
            aspect: req.aspect,
            format: 'PNG',
            imageUrl: seedImageUrl,
          });
        }, FAKE_LATENCY_MS);
      });
    },
  };
}
